import WhiteMidCTA from "../components/cta/WhiteMidCTA";
import FooterOne from "../components/footer/FooterOne";
import { Header } from "../components/header/Header";
import TitleSeven from "../components/section-title/TitleSeven";

const Why = () => {
  return (
    <>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
      </div>
      <TitleSeven />
      <WhiteMidCTA />
      <FooterOne />
    </>
  );
};

export default Why;
